import cacheKeys from '@/data/api/cacheKeys';
import { duplicateCart } from '@/data/api/request/cartRequests';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useDuplicateCart() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (cartId: string) => duplicateCart(cartId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [cacheKeys.carts.list] });
    },
  });
}
